// @flow
import createTimeSpentManager from 'app/packages/time-spent/TimeSpentManager';
import TimedPair from 'app/packages/time-spent/TimedPair';
import TimeSpent, { type TimeSpentProps } from 'app/packages/time-spent/TimeSpent';

export type { TimeSpentProps };
export { createTimeSpentManager, TimedPair, TimeSpent };
